module.exports = __webpack_public_path__ + "assets/img/doc_icon.0174001e.svg";